import apis from '@/apis';
import { RESET_DATA_PANEL } from './constants';
import { FETCH_QUERYCONDITIONS_INFO } from './filter-box';
export const QUERY_REAL_ACTIVITY_SQUARE = 'QUERY_REAL_ACTIVITY_SQUARE';
export const QUERY_REAL_ACTIVITY_TIME = 'QUERY_REAL_ACTIVITY_TIME';
export const QUERY_REAL_ACTIVITY_SOURCE = 'QUERY_REAL_ACTIVITY_SOURCE';
export const REAL_TABLE_INDEX = 'REAL_TABLE_INDEX';
export const REAL_ROOMID = 'REAL_ROOMID';
export const REAL_TOWERID = 'REAL_TOWERID';
export const QUERY_REAL_ACTIVITY_SQUARE_LOADING = 'QUERY_REAL_ACTIVITY_SQUARE_LOADING';
export const QUERY_REAL_ACTIVITY_SQUARE_TIME_LOADING = 'QUERY_REAL_ACTIVITY_SQUARE_TIME_LOADING';
export const QUERY_REAL_ACTIVITY_SQUARE__SOURCE_LOADING = 'QUERY_REAL_ACTIVITY_SQUARE__SOURCE_LOADING';
export const QUERY_REAL_ACTIVITY_SQUARE__NAME = 'QUERY_REAL_ACTIVITY_SQUARE__NAME';
export const RESET_REAL_SQUARE_DATA = 'RESET_SQUARE_DATA';
export const realActivitySquareData = (data) => (dispatch, getState) => {
  // const param = Object.assign({}, data)
  // param.plant = data.channel
  // param.planCode = data.activityCode
  dispatch({
    type: QUERY_REAL_ACTIVITY_SQUARE_LOADING,
    payload: true,
  });
  const param = Object.assign(
    {},
    { startTime: data.startTime },
    { endTime: data.endTime },
    { plant: data.channel },
    { planCode: data.activityCode }
  );
  apis.realActivitySquareData(param).then((res) => {
    if (res && res.ret === '0') {
      console.log('会场数据', res);
      dispatch({
        type: QUERY_REAL_ACTIVITY_SQUARE,
        payload: res.data.list,
      });
    } else {
      dispatch({
        type: QUERY_REAL_ACTIVITY_SQUARE,
        payload: [],
      });
    }
  });
};

export const realActivityTimeData = (data) => (dispatch, getState) => {
  dispatch({
    type: QUERY_REAL_ACTIVITY_SQUARE_TIME_LOADING,
    payload: true,
  });
  const param = Object.assign(
    {},
    { startTime: data.startTime },
    { endTime: data.endTime },
    { plant: data.channel },
    { roomId: data.roomId },
    { towerId: data.towerId }
  );
  // const param = Object.assign({}, { startTime: 1590076800000 }, { endTime: 1590076800000 }, { plant: data.channel }, { roomId: '00472681' })
  apis.realActivityTimeData(param).then((res) => {
    if (res && res.ret === '0') {
      console.log('会场分时数据数据请求的', res);
      dispatch({
        type: QUERY_REAL_ACTIVITY_TIME,
        payload: res.data,
      });
    } else {
      dispatch({
        type: QUERY_REAL_ACTIVITY_TIME,
        payload: [],
      });
    }
  });
};

export const realActivitySourceData = (data) => (dispatch, getState) => {
  dispatch({
    type: QUERY_REAL_ACTIVITY_SQUARE__SOURCE_LOADING,
    payload: true,
  });
  const param = Object.assign(
    {},
    { startTime: data.startTime },
    { endTime: data.endTime },
    { plant: data.channel },
    { roomId: data.roomId },
    { towerId: data.towerId }
  );
  // const param = Object.assign({}, { startTime: 1590076800000 }, { endTime: 1590076800000 }, { plant: data.channel }, { roomId: '00472681' })
  apis.realActivitySourceData(param).then((res) => {
    if (res && res.ret === '0') {
      console.log('分楼层素材数据请求的', res);
      dispatch({
        type: QUERY_REAL_ACTIVITY_SOURCE,
        payload: res.data.list,
      });
    } else {
      dispatch({
        type: QUERY_REAL_ACTIVITY_SOURCE,
        payload: [],
      });
    }
  });
};

export const updateTable = (tab) => (dispatch, getState) => {
  dispatch({
    type: REAL_TABLE_INDEX,
    payload: tab,
  });
};
export const updateRoomId = (roomId) => (dispatch, getState) => {
  dispatch({
    type: REAL_ROOMID,
    payload: roomId,
  });
};
export const updateTowerId = (roomId) => (dispatch, getState) => {
  dispatch({
    type: REAL_TOWERID,
    payload: roomId,
  });
};

export const updateSquareName = (squareName) => (dispatch, getState) => {
  dispatch({
    type: QUERY_REAL_ACTIVITY_SQUARE__NAME,
    payload: squareName,
  });
};

export const resetSquareData = function () {
  return {
    type: 'RESET_SQUARE_DATA',
  };
};

const initialState = {
  table: '0',
  roomId: null,
  towerId: null,
  // 活动会场数据list
  list: [],
  // 活动分时数据
  timelist: [],
  // 分楼层素材数据
  sourceList: [],
  loading: false,
  timeLoadng: false,
  sourceLoadng: false,
  downloadUrl: '',
  squareName: '',
};

export default function activitySquare(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case QUERY_REAL_ACTIVITY_SQUARE:
      return Object.assign({}, state, { list: payload }, { loading: false });
    case QUERY_REAL_ACTIVITY_TIME:
      return Object.assign(
        {},
        state,
        { timelist: payload.list },
        { downloadUrl: payload.downloadUrl },
        { timeLoadng: false }
      );
    case QUERY_REAL_ACTIVITY_SOURCE:
      return Object.assign({}, state, { sourceList: payload }, { sourceLoadng: false });
    case REAL_TABLE_INDEX:
      return Object.assign({}, state, { table: payload });
    case REAL_ROOMID:
      return Object.assign({}, state, { roomId: payload });
    case REAL_TOWERID:
      return Object.assign({}, state, { towerId: payload });
    case FETCH_QUERYCONDITIONS_INFO:
      // return Object.assign({}, state, { table: '0', timelist: [], sourceList: [], roomId: null })
      return initialState;
    case RESET_DATA_PANEL:
      return initialState;
    case QUERY_REAL_ACTIVITY_SQUARE_LOADING:
      return Object.assign({}, state, payload);
    case QUERY_REAL_ACTIVITY_SQUARE_TIME_LOADING:
      return Object.assign({}, state, payload);
    case QUERY_REAL_ACTIVITY_SQUARE__SOURCE_LOADING:
      return Object.assign({}, state, payload);
    case QUERY_REAL_ACTIVITY_SQUARE__NAME:
      return Object.assign({}, state, { squareName: payload });
    case RESET_REAL_SQUARE_DATA:
      return initialState;
    default:
      return state;
  }
}
